import { Button } from 'antd';
import Image from 'next/image';

const BannerAmbassador = () => {

  const clickApply = () => {
    var elmnt: any = document.getElementById('ambassador-form');
    if (elmnt) {
      const y = elmnt?.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
    }
  };

  return (
    <div id="ambassador-banner">
      <div className="custom-container">
        <div className="d-flex align-items-center text-white text-left">
          <div className="px-3">
            <div className="ambs-title mb-3">
              Be part of the prestigious group of Learnsic College Ambassadors
            </div>
            <div className="ambs-subtitle mb-3">
              Become a leader in your school or college!
            </div>
            <Button className="btn-secondary ambs-btn" onClick={clickApply}>
              APPLY NOW{' '}
            </Button>
          </div>
          <div className="d-md-block d-none d-lg-block">
            <Image src="/images/ambassador/girl.webp" height="1400" width="1400" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerAmbassador;
